export const domainName = "/api";
//

export const ITEMS_PER_PAGE = 10;
export const ITEMS_PER_PAGE_MULTILINE = 10;
export const MAX_FILE_SIZE = 100;
export const DASHBOARD_NOTIFICATION_COUNT = 10;
export const TRAN_TYPE = [
  { key: "Staff", value: 2 },
  { key: "Project Template", value: 3 },
  { key: "Task Template", value: 4 },
  { key: "SubTask Template", value: 5 },
  { key: "Project", value: 6 },
  { key: "Task", value: 7 },
  { key: "SubTask", value: 8 },
];
export const ACTION_TYPE = [
  { id: "LogInSuccess", value: "Log-In Successful" },
  { id: "LogInFailure", value: "Log-In Failed" },
  { id: "LogOut", value: "Log-Out" },
  { id: "AddRecord", value: "Added Record" },
  { id: "ChangeRecord", value: "Changed Record" },
  { id: "DeleteRecord", value: "Deleted Record" },
  { id: "ExportReport", value: "Exported Report" },
  { id: "PrintReport", value: "Printed Report" }
];
export const ENTITY_TYPE = [
  { id: 1, value: "Company" },
  { id: 2, value: "Staff" },
  { id: 3, value: "Project Template" },
  { id: 4, value: "Task Template" },
  { id: 5, value: "SubTask Template" },
  { id: 6, value: "Project Transaction" },
  { id: 7, value: "Task Transaction" },
  { id: 8, value: "SubTask Transaction" },
];


export const api = {
  signup: "/signup",
  login: "/login",
  logout: "/logout",
  listStaff: "/list_users",
  user: "/users",
  editeUser: "/user",
  addCompanyInfo: "/add_company_info",
  companyInfo: "/company_info",
  deleteStaff: "/delete_staff",
  activateUser: "/activate",
  deactivateUser: "/deactivate",
  userResetPassword: "/reset_password",
  setNewPassword: "/password_reset",
  taskTempList: "/list_task_templates",
  addTaskTemp: "/add_new_task_template",
  projectTempList: "/list_project_templates",
  addProjectTemp: "/add_new_project_template",
  subTaskTempList: "/list_subtask_templates",
  addSubTaskTemp: "/add_new_subtask_template",
  taskTemplate: "/task_template",
  subTaskTemp: "/subtask_template",
  deleteSubTaskTemp: "/delete_subtask_template",
  deleteTaskTemp: "/delete_task_template",
  deleteProjectTemp: "/delete_project_template",
  projectTemp: "/project_template",
  changePassword: "/change_password",
  addNewTask: "/add_new_task",
  getUserInfo: "/get_user_info",
  task: "/task",
  taskList: "/list_tasks",
  removeTask: "/delete_task",
  addTaskSubTask: "/add_new_subtask",
  subTaskList: "/list_subtasks",
  subTask: "/subtask",
  removeSubTask: "/delete_subtask",
  doneSubTask: "/done_subtask",
  checkSubtaskStatus: "/check_subtask_status",
  incompleteSubTask: "/incomplete_subtask",
  doneTask: "/done_task",
  startTask: "/start_task",
  acceptTask: "/accept_task",
  rejectTask: "/reject_task",
  cancelTask: "/cancel_task",
  dashboardCount: "/dashboard/count",
  getAttachmets: "/get_attachments",
  uploadAttachmets: "/upload",
  deleteAttachment: "/delete/attachment",
  editeAttachments: "/edit_attachments",
  overDueTask: "/dashboard/overdue",
  onGoingTask: "/dashboard/ongoing",
  underReviewTask: "/dashboard/under_review",
  upComingTask: "/dashboard/upcoming",
  checkSysConfig: "check_sysconfig_exists",
  updateSysConfig: "/update_sysconfigs",
  listSysconfigs: "/list_sysconfigs",
  addProject: "/add_new_project",
  listOfProjectTemp: "/list_project_templates",
  listOfProject: "/list_projects",
  project: "/project",
  deleteProject: "/delete_project",
  cancelProject: "/cancel_project",
  acceptProject: "/accept_project",
  rejectProject: "/reject_project",
  getNotificationList: "/list_notifications",
  getNotification: "/get_notification",
  addNotification: "/add_notification",
  getTableData: "/get_data",
  getNotificationCount: "/get_unread_notifications_count",
  getReports: "/reports",
  getUserActivity: "/list_user_activity",
  createUserActivityReports: "/create_user_activity_reports",
};
